module.exports = __webpack_public_path__ + "static/img/loginbanner.f195826f.png";